import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import Typography from "@mui/material/Typography";

export default function TextInputMui({
  type = "text",
  label,
  value,
  setValue,
  icon,
  required = false,
  readOnly = false,
  multiline = false,
  disabled = false,
  rows = 3,
  ...props
}) {
  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePassword = () => {
    setShowPassword((prev) => !prev);
  };

  const isPassword = type === "password";
  const inputType = isPassword ? (showPassword ? "text" : "password") : type;

  return (
    <TextField
      {...props}
      size="medium"
      disabled={disabled}
      type={inputType}
      label={
        required ? (
          <span>
            {label}{" "}
            <Typography
              component="span"
              sx={{ color: "red", fontSize: "14px", fontWeight: "bold" }}
            >
              *
            </Typography>
          </span>
        ) : (
          label
        )
      }
      value={value}
      onChange={(e) => setValue(e.target.value)}
      fullWidth
      variant="outlined"
      multiline={multiline}
      rows={multiline ? rows : 1}
      InputProps={{
        readOnly: readOnly,
        startAdornment:
          icon && <InputAdornment position="start">{icon}</InputAdornment>,
        endAdornment: isPassword ? (
          <InputAdornment position="end">
            <IconButton onClick={handleTogglePassword} edge="end" tabIndex={-1}>
              <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
            </IconButton>
          </InputAdornment>
        ) : null,
      }}
      sx={{
        "& .MuiOutlinedInput-root": {
          
          borderRadius: "12px",
          "& fieldset": {
            borderRadius: "8px",
          },
        },
      
      }}
    />
  );
}
